<template>
	<div class="display-flex width-100 section-container" :class="[smallScreenLayout ? 'small-screen' : 'flex-column']">
		<AnalyticsHorizontalCard
			v-for="(card, index) in cards"
			:key="index"
			:title="card.title"
			:value="card.value"
			:iconName="card.iconName"
			class="horizontal-card-container"
			:class="[index === cards.length - 1 ? '' : smallScreenLayout ? 'mr-5' : 'mb-5']"
		>
			<AnalyticsLineChart
				:data="card.data"
				:labels="card.labels"
				:chartId="`${index}`"
				class="chart-container"
				:datasetIdKey="`${index}`"
			/>
		</AnalyticsHorizontalCard>
	</div>
</template>
<script>
import AnalyticsMixin from '@/components/Analytics/mixins/AnalyticsMixin.js';
import AnalyticsLineChart from '@/components/Analytics/Charts/AnalyticsLineChart.vue';
import AnalyticsHorizontalCard from '@/components/Analytics/Cards/AnalyticsHorizontalCard.vue';
export default {
	name: 'AnalyticsDashboardRightSideTopSection',
	mixins: [AnalyticsMixin],
	props: { smallScreenLayout: { type: Boolean, default: false } },
	components: { AnalyticsLineChart, AnalyticsHorizontalCard },
	computed: {
		cards() {
			return [
				{
					title: 'Runs',
					labels: this.allDays,
					value: this.allRunsAmount,
					data: this.allRunsLinearArr,
					iconName: 'analytics-dashboard-run',
				},
				{
					title: 'Errors',
					labels: this.allDays,
					value: this.allErrorsAmount,
					data: this.allErrorsLinearArr,
					iconName: 'analytics-dashboard-errors',
				},
				{
					labels: this.allDays,
					title: 'Success rate',
					iconName: 'analytics-dashboard-success-rate',
					data: this.allSuccessRunsPercentageLinearArr,
					value: `${this.averageSuccessRunsPercentage}%`,
				},
			];
		},
	},
};
</script>
<style scoped lang="scss">
.chart-container {
	max-height: 54px;
	min-height: 54px;
	max-width: 130px;
	min-width: 130px;
}
.horizontal-card-container[max-width~='330px'] {
	.chart-container {
		max-width: 60px;
		min-width: 60px;
	}
}
.horizontal-card-container[min-width~='330px'] {
	.chart-container {
		max-width: 130px;
		min-width: 130px;
	}
}

.section-container[max-width~='820px'] {
	&.small-screen {
		flex-direction: column !important;
		justify-content: space-between;
		.chart-container {
			max-width: 300px;
			min-width: 300px;
		}
		.horizontal-card-container {
			margin-right: 0 !important;
			margin-top: 10px !important;
		}
	}
}
.section-container[min-width~='820px'] {
	&.small-screen {
		flex-direction: row;
		justify-content: space-between;
	}
}
</style>
